exports.components = {
  "component---src-app-index-tsx": () => import("./../../../src/app/index.tsx" /* webpackChunkName: "component---src-app-index-tsx" */)
}

